import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ roles, requireAdmin, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="App grain min-h-screen flex items-center justify-center">
        <div className="brand-serif text-2xl text-[#1d3a14]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !user.is_admin) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
